import { useSyncExternalStore } from 'react';
import type { BlogDraftPreviewCardData } from './blog-draft-preview';
import { dismissDocViewer } from './doc-viewer-presenter';
import { closeEmailReview } from './email-review-store';
import { closeSitePane } from './site-edit-store';

export type BlogReviewSendResult =
  | { status: 'sent' }
  | { status: 'busy' }
  | { status: 'newer'; card: BlogDraftPreviewCardData; sendComments: SendBlogComments };

export type SendBlogComments = (message: string) => BlogReviewSendResult;

export interface BlogReviewFlow {
  card: BlogDraftPreviewCardData;
  workspaceId: string;
  conversationId: string | null;
  sendComments: SendBlogComments;
  beside: boolean;
  revision?: string;
}

let flow: BlogReviewFlow | null = null;
const listeners = new Set<() => void>();

function set(next: BlogReviewFlow | null): void {
  flow = next;
  for (const l of [...listeners]) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function openBlogReview(next: BlogReviewFlow): void {
  closeEmailReview();
  if (next.beside) {
    closeSitePane();
    dismissDocViewer();
  }
  set(next);
}

export function closeBlogReview(): void {
  set(null);
}

export function closeBlogReviewBeside(): void {
  if (flow?.beside) set(null);
}

export function useBlogReviewFlow(): BlogReviewFlow | null {
  return useSyncExternalStore(subscribe, () => flow, () => null);
}
